<template>
  <center>
    <div class="mt-5 mb-5">
      <span class="mont-toggle">{{ $t('managePlan.monthly-payment') }}</span>
      <label class="switch">
        <input type="checkbox" @change="changePayPeriodToggle($event.target.checked)" :checked="check" />
        <span class="slider round"></span>
      </label>
      <span class="year-toggle">{{ text }}</span>
    </div>
  </center>
</template>

<script>
export default {
  name: 'PayPeriodToggle',
  props: {
    text: {
      type: String,
      default: null,
    },
  },
  computed: {
    check() {
      return this.$store.state.backOffice.steps.paymentPeriod == 1 ? false : true
    },
  },

  methods: {
    changePayPeriodToggle(value) {
      const _value = value == true ? 3 : 1
      this.$store.dispatch('backOffice/steps/updateInfoPropStep', { prop: 'paymentPeriod', data: _value })
    },
  },
}
</script>

<style lang="scss">
.switch {
  position: relative;
  display: inline-block;
  width: 55px;
  height: 25px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #7fcfe6;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 18px;
  width: 19px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #7fcfe6;
}

input:focus + .slider {
  box-shadow: 0 0 1px #7fcfe6;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 15px;
}

.slider.round:before {
  border-radius: 50%;
}

.year-toggle {
  margin-left: 10px;
  color: #868e96;
}

.mont-toggle {
  margin-right: 10px;
  color: #868e96;
}
</style>
